import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { prettifyMoney } from '@nexio/emvio-util-app';
import _ from 'lodash';
import './ColorDollarAmountCell.scss';

export default class ColorDollarAmountCell extends Component {
    static propTypes = {
        amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        currencyCode: PropTypes.string,
        determineIsNegative: PropTypes.func,
        overrideText: PropTypes.string
    };

    render() {
        let amount = this.props.amount;
        if (_.isString(amount)) {
            amount = Number(amount);
        }

        return (
            <div className={classNames({ 'negative-amount': this.props.determineIsNegative ? this.props.determineIsNegative(amount) : amount < 0 })}>
                {this.props.overrideText && _.isNil(amount) ? this.props.overrideText : prettifyMoney(amount, this.props.currencyCode)}
            </div>
        );
    }
}
